import React, { Component } from "react";
import PropTypes from "prop-types";
import { getUrlParameters } from "cxa-utils";
import messages from "components/messagesDescription";
import { injectIntl, intlShape } from "react-intl";

class TrackSsoUrlComponent extends Component {
  constructor(props) {
    super(props);
    this.showPopup = this.showPopup.bind(this);
  }

  // To allow SSO external link handshake
  //
  // @param serviceProviderId - configurable from admin portal
  // @param functionReferenceId - configurable from admin portal
  // @param getShortLivedToken - pass down action from parent component
  openSSOExternalLink(serviceProviderId, functionReferenceId, { getShortLivedToken, intl }) {
    const text = intl.formatMessage({ ...messages.claims.externalClaimConfirmation });
    if (window.confirm(text) && getShortLivedToken) {
        // open new tab before execute action to prevent cross domain
        const wnd = window.open("", "_blank");

        getShortLivedToken().then(response => {
          const { body: { slToken } = {} } = response;
          if (!slToken) {
            return;
          }
          const url = `/sso/sp/redirection?serviceProviderId=${serviceProviderId}&slToken=${slToken}&functionReferenceId=${functionReferenceId}`;

          wnd.location = url;
          wnd.focus();
        });
    }
  }

  trackSsoLink(e, obj) {
    const anchor = e.target.closest("a");
    const params = getUrlParameters(anchor || e.target);

    if ((anchor.search || e.target.search) && params.functionReferenceId && params.spId) {
      e.preventDefault();
      obj.openSSOExternalLink(params.spId, params.functionReferenceId, obj);
    }
  }

  showPopup(e) {
    const { getShortLivedToken, intl } = this.props;

    this.trackSsoLink(e, {
      openSSOExternalLink: this.openSSOExternalLink,
      getShortLivedToken,
      intl,
    });
  }

  componentDidMount() {
    document.addEventListener("click", this.showPopup, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.showPopup, true);
  }

  render() {
    return null;
  }
}

TrackSsoUrlComponent.propTypes = {
  getShortLivedToken: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(TrackSsoUrlComponent);



// WEBPACK FOOTER //
// ./components/common/TrackSsoUrlComponent.js